
<template>
  <card>
    <h4 slot="header" class="card-title d-md-flex justify-content-between">
      <span>Abone Listesi</span>
      <div>
        <router-link v-b-tooltip title="Yeni Abone Ekle" :to="{ path: 'newsletter/new-subscriber/'}" class="btn btn-primary" tag="li"><i class="fas fa-plus"></i> Yeni Abone Ekle</router-link>
        <router-link v-b-tooltip title="Toplu E-Posta Gönder" :to="{ path: 'newsletter/send-bulk-email/'}" class="btn btn-success btn-fill" tag="li"><i class="fas fa-plus"></i> Toplu E-Posta Gönder</router-link>
      </div>
    </h4>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption >Toplam: {{total}}</caption>
      <thead class="thead-dark">
        <th>E-Posta</th>
        <th>İşlemler</th>
      </thead>
      <tbody>
        <tr v-for="item in table" :key="item.id">
          <td>{{item.email}}</td>
          <td style="width:15%">
            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="item.is_subscribed" v-on:click="deactivate(item.id)" v-b-tooltip title="Aboneliği Kaldır" id="deactivate-item.id"><i class="fas fa-unlink"></i> Aboneliği İptal Et</a>
            <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="!item.is_subscribed" v-b-tooltip v-on:click="activate(item.id)" title="Aboneliğe al" id="activate-item.id"><i class="fas fa-link"></i> Aboneliği Aktif Et</a>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation small">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-bind:class="{active: isActive(current)}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>


  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        post:{
          is_subscribed:0
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      deactivate: function(id){
        this.toggleLoader()
        this.post.is_subscribed = 0
        this.$http.post('/api/newsletter/edit/' + id, this.post).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Abonelik İptal Edildi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      activate: function(id){
        this.toggleLoader()
        this.post.is_subscribed = 1
        this.$http.post('/api/newsletter/edit/' + id, this.post).then(
          response => {
            this.notifier('top', 'right', 'success', 'Abonelik Aktif Edildi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'all') {
        this.toggleLoader()
        this.type = t
        var url = '/api/filter/newsletter/limit/' + this.limit + '/page/' + p
        
        this.$http
        .get(url)
        .then(
          response => {
            this.table = response.body.data
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            console.log(response.body)
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
            this.toggleLoader()
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            this.toggleLoader()
          }
          )
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/NewsletterModules/Index.vue